import logo from './logo.svg';
import './App.css';
import RouteStations from '../src/components/RouteStations'
import Navbar from './components/Navbar';

function App() {
  return (
    <>
    <RouteStations/>
    
    </>
  );
}

export default App;
